import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {PreferenceService} from '../../../services/preference.service';
import { SmartPowerReportService } from '../../../services/smart-power-report.service';
import { switchMap, withLatestFrom, map, catchError, tap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { SmartPowerReportActions } from '../actions/smart-power-report.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';

@Injectable()
export class SmartPowerReportEffects {
  constructor(private actions$: Actions<SmartPowerReportActions>,
              private store$: Store<fromStore.State>,
              private smartPowerReportService: SmartPowerReportService,
              private preferenceService: PreferenceService,
            ) {}

  ReadSmartPowerReportList$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.SmartPowerReportActionTypes.GetSmartPowerReportList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = { ...action.payload, otp: user.otp };
      return this.smartPowerReportService.ReadSmartPowerReportList(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpsertSmartPowerReportList(res.msg.body)];
          } else {
            return of(new featureActions.GetSmartPowerReportListFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetSmartPowerReportListFail());
        })
      );
    })
  ));

  ReadSmartPowerReport$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.SmartPowerReportActionTypes.GetSmartPowerReport),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      let param = {};
      param = {
        otp : user.otp,
        Id: action.payload.Id
      }
      return this.smartPowerReportService.ReadSmartPowerReport(param).pipe(
        switchMap((res) => {
          if (res.result) {
            return [new featureActions.UpsertSmartPowerReport(res.msg.body)];
          } else {
            return of(new featureActions.GetSmartPowerReportFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetSmartPowerReportFail());
        })
      );
    })
  ));

  UpdateSmartPowerReport$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.SmartPowerReportActionTypes.UpdateSmartPowerReport),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateSmartPowerReport
      };
      const params = { ...action.payload, otp: user.otp };
      return this.smartPowerReportService.UpdateSmartPowerReport(params).pipe(
        switchMap((res) => {
          if (res.result) {
            return [new featureActions.UpdateSmartPowerReportSuccess(res.msg.body), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Update SmartPowerReport Success' })];
          } else {
            return of(new featureActions.UpdateSmartPowerReportFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.UpdateSmartPowerReportFail());
        })
      );
    })
  ));
  
  DeleteSmartPowerReport$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.SmartPowerReportActionTypes.DeleteSmartPowerReport),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteSmartPowerReport
      };
      let param = {};
      param = {
        otp : user.otp,
        id: action.payload.id
      }
      return this.smartPowerReportService.DeleteSmartPowerReport(param).pipe(
        switchMap((res) => {
          if (res.result) {
            return [new featureActions.DeleteSmartPowerReportSuccess(res.msg.body), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Delete SmartPowerReport Success' })];
          } else {
            return of(new featureActions.DeleteSmartPowerReportFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.DeleteSmartPowerReportFail());
        })
      );
    })
  ));
  
  ReadSmartPowerReportData$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.SmartPowerReportActionTypes.GetSmartPowerReportData),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = { ...action.payload, otp: user.otp };
      return this.smartPowerReportService.ReadSmartPowerReportData(params).pipe(
        switchMap((res) => {
          if (res.result) {
            return [new featureActions.UpsertSmartPowerReportData(res.msg.body)];
          } else {
            return of(new featureActions.GetSmartPowerReportDataFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetSmartPowerReportDataFail());
        })
      );
    })
  ));
}
